import type { Document } from '@/types/document';

const STORAGE_KEY = 'documents';

type DocumentUpdateCallback = (documents: Document[]) => void;
const subscribers = new Set<DocumentUpdateCallback>();

export function getStoredDocuments(): Document[] {
  const documents = localStorage.getItem(STORAGE_KEY);
  if (!documents) {
    // Initialize with mock documents
    const mockDocuments: Document[] = [
      {
        id: '1',
        name: 'Invoice-2024-001.pdf',
        type: 'invoice',
        url: 'https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/web/compressed.tracemonkey-pldi-09.pdf',
        size: 245760, // 240KB
        mimeType: 'application/pdf',
        uploadDate: '2024-03-15T10:30:00Z',
        uploadedBy: 'system',
      },
      {
        id: '2',
        name: 'Delivery-Note-123.pdf',
        type: 'delivery-note',
        url: 'https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/web/compressed.tracemonkey-pldi-09.pdf',
        size: 153600, // 150KB
        mimeType: 'application/pdf',
        uploadDate: '2024-03-14T15:45:00Z',
        uploadedBy: 'system',
      },
      {
        id: '3',
        name: 'Receipt-A1B2C3.jpg',
        type: 'receipt',
        url: 'https://example.com/documents/receipt-a1b2c3.jpg',
        size: 512000, // 500KB
        mimeType: 'image/jpeg',
        uploadDate: '2024-03-13T09:15:00Z',
        uploadedBy: 'system',
      },
      {
        id: '4',
        name: 'PO-2024-0123.pdf',
        type: 'purchase-order',
        url: 'https://example.com/documents/po-0123.txt',
        size: 307200, // 300KB
        mimeType: 'text/plain',
        uploadDate: '2024-03-12T14:20:00Z',
        uploadedBy: 'system',
      },
      {
        id: '5',
        name: 'Packing-List-456.txt',
        type: 'packing-list',
        url: 'https://example.com/documents/packing-456.txt',
        size: 102400, // 100KB
        mimeType: 'text/plain',
        uploadDate: '2024-03-11T11:10:00Z',
        uploadedBy: 'system',
      }
    ];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(mockDocuments));
    return mockDocuments;
  }
  return JSON.parse(documents);
}

export function addStoredDocument(document: Document) {
  const documents = getStoredDocuments();
  documents.push(document);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(documents));
  notifySubscribers(documents);
  return document;
}

export function deleteStoredDocument(documentId: string) {
  const documents = getStoredDocuments();
  const filteredDocuments = documents.filter(d => d.id !== documentId);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(filteredDocuments));
  notifySubscribers(filteredDocuments);
}

function notifySubscribers(documents: Document[]) {
  subscribers.forEach(callback => callback(documents));
}

export function subscribeToDocumentUpdates(callback: DocumentUpdateCallback) {
  subscribers.add(callback);
  return () => {
    subscribers.delete(callback);
  };
}